import React, { useEffect, useState } from "react";
import BannerSection from "../Component/BannerSection";
import { axiosInstance } from "../Component/utils/axiosInstance";
import Layout from "../Component/Layout/Layout";
import Loader from "../Component/Loader";
// import WishlistCard from "../Component/Dashboard/WishlistCard";
import MenuCart from "../Component/Menu/MenuCart";
import ShareSocialModal from "../Component/ShareSocialModal";

const Favourite = () => {
  const [allWishlist, setAllWishlist] = useState([]);
  const [loader, setloader] = useState(false);
  const [url, setUrl] = useState("");
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);

  const getAllWishlist = async () => {
    setloader(true);
    try {
      await axiosInstance.get("user/whishlist").then((response) => {
        if (response?.data?.status === true) {
          setloader(false);
          setAllWishlist(response?.data?.whishlists);
        }
      });
    } catch (error) {
      setloader(true);
    }
  };
  useEffect(() => {
    getAllWishlist();
  }, []);
  return (
    <Layout>
      <BannerSection
        heading="favourite"
        image="/images/menu_banner.webp"
        description="favourite"
      />
      <section class="menu_page mt_100 xs_mt_70 mb_100 xs_mb_70">
        <div class="container">
          {loader ? (
            <Loader />
          ) : (
            <div className="dashoard_wishlist">
              {allWishlist ? (
                <div className="row">
                  {allWishlist?.map((e, i) => (
                    <MenuCart
                      heart={true}
                      setShowModal={setShowModal}
                      setUrl={setUrl}
                      getAllWishlist={getAllWishlist}
                      productData={e?.product}
                    />
                  ))}
                </div>
              ) : (
                <>No Favourite Data Found..!</>
              )}
            </div>
          )}
        </div>
      </section>
      <ShareSocialModal
        showModal={showModal}
        handleClose={handleClose}
        url={url}
      />
    </Layout>
  );
};

export default Favourite;
